import { AnnotationsType } from 'app/business-logic/domain-models/Annotations';

const { controlledTest, approximateExposure, fieldObservation, odourObservation, airQualityObservation, disregard } =
  AnnotationsType;

const create = (root: string) => {
  return {
    controlledTest: () => `${root}/create/${controlledTest.slug}`,
    approximateExposure: () => `${root}/create/${approximateExposure.slug}`,
    fieldObservation: () => `${root}/create/${fieldObservation.slug}`,
    odourObservation: () => `${root}/create/${odourObservation.slug}`,
    airQualityObservation: () => `${root}/create/${airQualityObservation.slug}`,
    disregard: () => `${root}/create/${disregard.slug}`,
  };
};

const edit = (root: string) => {
  return {
    controlledTest: () => `${root}/edit/${controlledTest.slug}/:id`,
    approximateExposure: () => `${root}/edit/${approximateExposure.slug}/:id`,
    fieldObservation: () => `${root}/edit/${fieldObservation.slug}/:id`,
    odourObservation: () => `${root}/edit/${odourObservation.slug}/:id`,
    airQualityObservation: () => `${root}/edit/${airQualityObservation.slug}/:id`,
    disregard: () => `${root}/edit/${disregard.slug}/:id`,
  };
};

export const annotationsRoutes = (root: string) => ({
  root,
  create: create(root),
  edit: edit(root),
});
